export default "__VITE_ASSET__DSwcpXsx__"